<template>
  <div>
    <VisualHero
      image="/assets/img/visual/ucrs-visual-acquistarecasa.png"
      background-color="bg-black-light"
    >
      <template slot="title"> Trova la casa giusta per te </template>
    </VisualHero>
    <BreadcrumbsWithShareAccordion :breadcrumbs="breadcrumbs" />
    <section class="pt-8 md:pt-20">
      <div class="container">
        <div class="mb-24 lg:mb-0 max-w-400">
          <h2 class="lg:block font-light text-2xl md:text-4xl mb-8 md:mb-20">
            Acquistare casa con UniCredit RE Services.
          </h2>
          <h3 class="mb-4 font-bold">
            Per comprare la tua casa affidati a UniCredit RE Services, la nuova
            società di intermediazione immobiliare del Gruppo UniCredit S.p.A.
          </h3>
          <p class="mb-4">
            Con UniCredit RE Services puoi trovare in vendita immobili di
            diverse tipologie: dall'appartamento in città all'attico di pregio,
            dal rustico da ristrutturare alla vecchia cascina in campagna. Se
            stai cercando una casa nuova, puoi scegliere tra numerose nuove
            costruzioni in vendita, in cui ogni soluzione viene corredata da
            foto e planimetrie.
          </p>
          <p class="mb-4">
            Se, invece, sei alla ricerca del posto ideale per aprire la tua
            attività, proponiamo anche una sezione di immobili commerciali:
            locali, ma anche uffici e negozi, magazzini e capannoni, laboratori
            e showroom.
          </p>
          <p class="mb-4">
            UniCredit RE Services è un partner affidabile in grado di
            affiancarti nell'acquisto di un immobile, mettendoti a disposizione
            una rete di consulenti immobiliari qualificati per:
          </p>
          <ul class="list-disc list-inside pl-16">
            <li class="mb-2">
              accedere ad un'offerta di immobili selezionata in Italia,
            </li>
            <li class="mb-2">contare sui migliori servizi in tempi certi,</li>
            <li class="mb-2">
              avere l'assistenza e la consulenza necessarie nelle diverse fasi
              della compravendita.
            </li>
          </ul>
        </div>

        <div class="text-center mb-16">
          <a class="ucrs-button ucrs-button--primary" href="/venditaimmobili"
            >Inizia ora la ricerca della tua casa</a
          >
        </div>

        <StripBannerSellEvaluateHome />
      </div>
    </section>
  </div>
</template>

<script>
// Components
import BreadcrumbsWithShareAccordion from '~/components/BreadcrumbsWithShareAccordion.vue'
import StripBannerSellEvaluateHome from '~/components/StripBannerSellEvaluateHome.vue'
import VisualHero from '~/components/VisualHero.vue'

export default {
  components: {
    BreadcrumbsWithShareAccordion,
    StripBannerSellEvaluateHome,
    VisualHero,
  },
  async asyncData({ route, $axios }) {
    let meta
    await $axios
      .get('/_api/api/v1/meta', {
        params: {
          slug: route.path,
        },
      })
      .then((res) => {
        meta = res.data.data
      })
      .catch(() => {
        meta = {
          title: 'Acquistare Casa con UniCredit RE Services',
          description:
            "Per comprare la tua casa affidati a UniCredit RE Services, un partner affidabile in grado di affiancarti nell'acquisto di un immobile",
        }
      })

    return { meta }
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$store.state.auth.loggedIn ? 'La mia homepage' : 'Home',
          href: '/',
        },
        {
          text: 'Acquistare casa con UniCredit RE Services.',
        },
      ],
    }
  },
  head() {
    return {
      title: this.meta.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta.description,
        },
      ],
    }
  },
}
</script>
